import { fork, put, takeLatest } from 'redux-saga/effects';

import { actions } from 'domain/runner';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';
import Api, { callApi } from 'domain/api';

export function* runAction({ payload: { id, action } }) {
  try {
    const { data: payload } = yield callApi(Api.runnerAction, { id, action });
    yield put({
      type: actions.fetchItemAction.success,
      payload,
    });
  } catch (e) {

  }
}

export default function* navigator(args) {
  yield takeLatest(actions.runnerAction.type, runAction);
  yield fork(itemNavigator, { modelName: 'Runner', actions, editableFields }, args);
}
